/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SecretManagerAccount = 'ADMIN' | 'SHADOW';

export const SecretManagerAccount = {

    ADMIN: 'ADMIN' as SecretManagerAccount,

    SHADOW: 'SHADOW' as SecretManagerAccount
};

